import React from 'react';
import dynamic from 'next/dynamic';
import { NavBarContainer } from '@components/navigation';
import { withAgentLogin } from '@components/hoc/with-auth/with-auth';
import { Grid } from '@mui/material';
import { Theme, ThemeProps } from '@theme/base';
import { useTheme } from '@emotion/react';
import { SeoComponent, TextComponent } from '@model/content';
import { Keyable } from '@model/common';
import { AgentsPageProps } from '@model/common/pages/agent-pages';
import { SectionTitle } from '@components/common/section-title';
import { MaxContentWidth } from '@components/common/layout';
import { PageSeoContainer } from '@components/content';
import { SectionSeparator } from '@styles/layout';
import styled from '@emotion/styled';
import { Footer } from '@components/footer';
import { Breadcrumb } from '@components/common/breadcrumb';
import { Item } from '@components/breadcrumbs/item';
import SearchTabsBar from '@components/search/SearchTabsBar';
import { ComponentHandles } from '@util/content';

const DynamicSidebarContainer = dynamic(
  () => import('../../components/agents/sidebar/SidebarContainer').then((e) => e.SidebarContainer),
  {
    ssr: false
  }
);

export interface AgentsGenericPageLayoutProps extends AgentsPageProps {
  breadcrumbs?: Array<Item>;
  main: JSX.Element;
  textProps?: Keyable;
}

const ContentContainer = styled(MaxContentWidth)(({ theme }: ThemeProps) => ({
  margin: '0 auto',
  paddingLeft: theme.custom.spacing.medium,
  paddingRight: theme.custom.spacing.medium,
  marginBottom: theme.custom.spacing.xxLarge
}));

const AgentsGenericPageLayout = ({ pageConfig, main, breadcrumbs, textProps }: AgentsGenericPageLayoutProps) => {
  const theme: Theme = useTheme();
  const pageSeo = pageConfig?.components?.find(({ handle }) => handle === ComponentHandles.PAGE_SEO);
  const title = pageConfig?.components?.find(({ handle }) => handle === ComponentHandles.TITLE);

  return (
    <div>
      {pageSeo && <PageSeoContainer {...(pageSeo as SeoComponent)} />}
      <NavBarContainer renderSearch={<SearchTabsBar condensed />} />
      {breadcrumbs?.length && <Breadcrumb items={breadcrumbs} />}
      <SectionSeparator />
      <ContentContainer>
        <Grid container={true} spacing={theme.custom.gridSpacing.default}>
          <Grid item xs={12} md={8}>
            {title && <SectionTitle heading={(title as TextComponent).value} headingProps={textProps} />}
            {main}
          </Grid>
          <Grid item xs={12} md={4}>
            <DynamicSidebarContainer />
          </Grid>
        </Grid>
      </ContentContainer>
      <Footer />
    </div>
  );
};

export default withAgentLogin(AgentsGenericPageLayout);
